export default [
    {
        title: "Camaronera",
        fontIcon: "shrimp",
        resource: "Camaronera",
        action: "ver-camaronera", 
        children: [{
            title: "Dashboard",
            icon: "LayoutIcon",
            resource: "Camaronera",
            action: "ver-camaronera-dashboard",
            route: "camaronera-dashboard"
        },

        {
            title: "Configuracion",
            icon: "SettingsIcon",
            resource: "Camaronera",
            action: "ver-camaronera-configuracion",
           
        },
        {
            title: "Mantenimiento",
            icon: "EditIcon",
            resource: "Camaronera",
            action: "ver-camaronera-mantenimiento",
            children: [{
                route: "camaronera-mantenimiento-empleado",
                title: "Empleados",
                resource: "Camaronera",
                action: "ver-camaronera-mantenimiento-empleado"
            }]
           
        },
        {
            title: "Transacciones",
            fontIcon: "exchange-alt",
            resource: "Camaronera",
            action: "ver-camaronera-transacciones",
            children: [{
                route: "camaronera-transacciones-gestion-cobranza",
                title: "Gestión Cobranzas",
                resource: "Camaronera",
                action: "ver-camaronera-transacciones-gestion-cobranza"
            },{
                route: "camaronera-transacciones-abonos",
                title: "Abonos",
                resource: "Camaronera",
                action: "ver-camaronera-transacciones-abonos"
            },]
           
        },
        {
            title: "Informes",
            fontIcon: "file-prescription",
            resource: "Camaronera",
            action: "ver-camaronera-informes",
            children: [{
                route: "camaronera-informes-cupo-x-colaborador",
                title: "Cupos por colaborador",
                resource: "Camaronera",
                action: "ver-camaronera-informes-cupo-x-colaborador"
            },
            {
                route: "camaronera-informes-estado-cuenta-empleado",
                title: "Estado de cuenta colaborador",
                resource: "Camaronera",
                action: "ver-camaronera-informes-estado-cuenta-empleado"
            },
            {
                route: "camaronera-informes-facturas-empleado",
                title: "Facturas por colaborador",
                resource: "Camaronera",
                action: "ver-camaronera-informes-facturas-empleado"
            },
        ]
        },     
    
    
    ]
    }
]